export default __webpack_public_path__ + "static/media/message.46195a1b.png";